<template>
  <b-row>
    <b-col lg="12">
      <!-- .name -->
      <validation-observer ref="registerForm" #default="{ invalid }">
        <b-form>
          <b-row>
            <b-col lg="12">
              <b-tabs content-class="mt-3">
                <b-tab
                  :title="lang.name"
                  v-for="lang in languages"
                  :key="lang.id"
                >
                  <!-- .title -->
                  <b-col lg="12">
                    <b-form-group
                      id="input-group-7"
                      :label="$t('pages.title')"
                      label-for="input-7"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="title"
                        vid="title"
                        rules="required"
                      >
                        <b-form-input
                          id="input-7"
                          v-model="title[lang.code]"
                          type="text"
                          :placeholder="$t('pages.title')"
                          :state="errors.length > 0 ? false : null"
                        >
                        </b-form-input>
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-tab>
              </b-tabs>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <!-- .image -->
            <b-col lg="6">
              <b-form-group
                id="input-group-4"
                :label="$t('menu.type')"
                label-for="input-4"
              >
                <div class="demo-inline-spacing">
                  <b-form-radio
                    v-model="newItem.type"
                    name="some-radios"
                    value="url"
                  >
                    URL
                  </b-form-radio>
                  <b-form-radio
                    v-model="newItem.type"
                    name="some-radios"
                    value="pages"
                  >
                    Page Link
                  </b-form-radio>
                  <b-form-radio
                    v-model="newItem.type"
                    name="some-radios"
                    value="list"
                  >
                    Page
                  </b-form-radio>
                </div>
              </b-form-group>
            </b-col>

            <b-col lg="6" v-if="newItem.type != 'list'">
              <b-form-group
                id="input-group-7"
                :label="$t('menu.path')"
                label-for="input-7"
              >
                <b-form-input
                  id="input-7"
                  v-model="newItem.path"
                  type="text"
                  :placeholder="$t('menu.path')"
                >
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col lg="6" v-if="newItem.type == 'list'">
              <b-form-group
                id="input-group-7"
                :label="$t('menu.page')"
                label-for="input-7"
              >
                <b-form-select
                  v-model="newItem.path"
                  :options="pages"
                  size="sm"
                  class="mt-1"
                  label-field="text"
                  value-field="value"
                />
              </b-form-group>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col lg="6">
              <b-button
                block
                :disabled="invalid"
                variant="primary"
                @click="submit()"
              >
                <i class="fa fa-plus" /> {{ $t("site.save") }}
              </b-button>
            </b-col>
            <b-col lg="6">
              <b-button block  @click="goToTable()" variant="success">
                <i class="fas fa-ban"></i> {{ $t("site.cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-col>
  </b-row>
</template>

<script>
import Controller from "@/Controllers/MenuController";
import config from "@/config/config";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import LanguagesController from "@/Controllers/LanguagesController";
export default {
  name: "PagesForm",
  props: ["newItem"],
  components: {
    ValidationProvider,
    ValidationObserver,
    required,
  },
 
  data() {
    return {
      file: {},
      
      youtube: [],
      languages: [],
      title: {},
      pages: [
        {
          text: this.$i18n.t("menu.about_the_platform"),
          value: "about",
        },
        {
          text: this.$i18n.t("menu.faculty_members"),
          value: "teachers",
        },
        {
          text: this.$i18n.t("menu.contact_us"),
          value: "contact-us",
        },
        {
          text: this.$i18n.t("menu.blog"),
          value: "blog",
        },
        {
          text: this.$i18n.t("menu.courses"),
          value: "courses-list",
        },
        {
          text: this.$i18n.t("menu.news"),
          value: "news",
        },
        {
          text: this.$i18n.t("menu.common_questions"),
          value: "FAQ",
        },
        {
          text: this.$i18n.t("menu.all_programs"),
          value: "programs-list",
        },
        {
          text: this.$i18n.t("menu.login"),
          value: "signin",
        },
        {
          text: this.$i18n.t("menu.video_albums"),
          value: "videos-albumes",
        },
      ],
    };
  },
  async created() {
    this.languages = await new LanguagesController().GetActivelanguages();
  },
  methods: {
    async    goToTable() {
      this.$parent.$parent.$children[0].$children[0].$refs.table.refresh();
      this.$parent.$parent.firstTab();
    },
    async submit() {
      this.languages.forEach((element) => {
        this.newItem[element.code] = {
          title: this.title[element.code],
        };
      });
      this.newItem.menu_id=this.$route.params.id
      let ret = await new Controller().From(this.newItem, "FormData");
      if (ret) {
          this.$parent.$parent.$children[0].$children[0].dataProvider();
        this.$parent.$parent.firstTab();
      }
    },
  },
  watch: {
    newItem(old) {
      this.languages.forEach((element) => {
        if (old.translations) {
          let locale = old.translations.find((a) => a.locale == element.code);
          this.$set(this.title, element.code, locale.title);
        }
      });
    },
  },
};
</script>

